import NgrxAuth from '../../auth/Auth'
import { CALL_API } from '../../util/RBRestMiddleware'

export const MEMBER_SUMMARY_LOADING = 'MEMBER_SUMMARY_LOADING'
export const MEMBER_SUMMARY_SUCCESS = 'MEMBER_SUMMARY_SUCCESS'
export const MEMBER_SUMMARY_FAILED = 'MEMBER_SUMMARY_FAILED'

export const PENSION_LOADING = 'PENSION_LOADING'
export const PENSION_SUCCESS = 'PENSION_SUCCESS'
export const PENSION_FAILED = 'PENSION_FAILED'

export const fetchMemberSummary = (onSuccess) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/members/${NgrxAuth.memberId}/summary`,
        prefix: 'MEMBER_SUMMARY',
        onSuccess
      }
    })
  }
}

export const fetchPension = (onSuccess, onError) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/members/${NgrxAuth.memberId}/Pension`,
        prefix: 'PENSION',
        onSuccess,
        onError
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/memberSummaryActions.js